const paths: Record<string, string> = {
  select: "m5 3 14 9-7 2-3 7Z",
  hand: "M8 12V5a2 2 0 0 1 4 0v6-8a2 2 0 0 1 4 0v9-6a2 2 0 0 1 4 0v9c0 5-3 7-7 7-3 0-5-2-7-5l-3-4a2 2 0 0 1 3-2l2 2",
  pen: "m4 20 1-5L16 4l4 4L9 19Zm10-14 4 4",
  highlight: "m5 15 10-11 5 5-11 10Zm-1 6h10M5 15l4 4",
  erase: "m3 14 9-10 9 8-8 9H9Zm4-4 9 8M3 22h19",
  rect: "M4 4h16v16H4Z",
  ellipse: "M21 12a9 7 0 1 1-18 0 9 7 0 1 1 18 0",
  line: "M4 20 20 4",
  arrow: "M4 20 20 4M9 4h11v11",
  triangle: "m12 3 10 18H2Z",
  diamond: "m12 2 10 10-10 10L2 12Z",
  text: "M4 5h16M12 5v15M8 20h8",
  note: "M4 3h16v12l-6 6H4Zm10 18v-6h6M8 8h8M8 12h5",
  image: "M3 3h18v18H3Zm0 13 5-5 5 5 3-3 5 5M7 7h1",
  undo: "M8 4 3 9l5 5M3 9h10a7 7 0 0 1 0 14",
  redo: "m16 4 5 5-5 5m5-5H11a7 7 0 0 0 0 14",
  duplicate: "M8 8h13v13H8ZM3 16V3h13",
  delete: "M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7",
  front: "m3 11 9-5 9 5-9 5Zm0 5 9 5 9-5M12 2v5",
  back: "m3 6 9-5 9 5-9 5Zm0 5 9 5 9-5M12 17v5",
  layers: "m3 6 9-5 9 5-9 5Zm0 6 9 5 9-5m-18 6 9 5 9-5",
  fullscreen: "M3 9V3h6m6 0h6v6M3 15v6h6m6 0h6v-6",
  export: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
  plus: "M12 4v16M4 12h16",
  minus: "M4 12h16",
  close: "m5 5 14 14M5 19 19 5",
};
export function BoardIcon({ name }: { name: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name] ?? paths.pen} />
    </svg>
  );
}
